module.exports = __webpack_public_path__ + "static/media/search-location.228e8d45.svg";